type ShareOutcome = "shared" | "copied" | "cancelled" | "failed";

/**
 * Hand a link to the phone's own share sheet where there is one, and put it on
 * the clipboard where there is not. Closing the share sheet is not a failure.
 */
export async function shareLink(
  url: string,
  title: string,
  nav: Pick<Navigator, "share" | "clipboard"> = navigator,
): Promise<ShareOutcome> {
  if (typeof nav.share === "function") {
    try {
      await nav.share({ title, url });
      return "shared";
    } catch (err) {
      if (err instanceof DOMException && err.name === "AbortError") return "cancelled";
    }
  }
  try {
    await nav.clipboard.writeText(url);
    return "copied";
  } catch {
    return "failed";
  }
}

/** What to say once the link has gone, or null when there is nothing to say. */
export function shareToast(outcome: ShareOutcome): string | null {
  if (outcome === "copied") return "Link copied";
  if (outcome === "failed") return "Couldn't copy the link";
  return null;
}
